import * as tslib_1 from "tslib";
import { Matrix3D, Vector3D } from "@awayjs/core";
import { ContextGLDrawMode, ContextGLProgramType, GL_TriangleElements } from "@awayjs/stage";
/**
 *
 * @class away.pool.GL_SkyboxElements
 */
var GL_SkyboxElements = (function (_super) {
    tslib_1.__extends(GL_SkyboxElements, _super);
    function GL_SkyboxElements() {
        var _this = _super.apply(this, arguments) || this;
        _this._skyboxProjection = new Matrix3D();
        return _this;
    }
    Object.defineProperty(GL_SkyboxElements.prototype, "elementsType", {
        get: function () {
            return GL_SkyboxElements.elementsType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GL_SkyboxElements.prototype, "elementsClass", {
        get: function () {
            return GL_SkyboxElements;
        },
        enumerable: true,
        configurable: true
    });
    GL_SkyboxElements._includeDependencies = function (shader) {
    };
    /**
     * @inheritDoc
     */
    GL_SkyboxElements._getVertexCode = function (shader, registerCache, sharedRegisters) {
        var code = "";
        //get the projection coordinates
        var position = (shader.globalPosDependencies > 0) ? sharedRegisters.globalPositionVertex : sharedRegisters.animatedPosition;
        //reserving vertex constants for projection matrix
        var viewMatrixReg = registerCache.getFreeVertexConstant();
        registerCache.getFreeVertexConstant();
        registerCache.getFreeVertexConstant();
        registerCache.getFreeVertexConstant();
        shader.viewMatrixIndex = viewMatrixReg.index * 4;
        var scenePosition = registerCache.getFreeVertexConstant();
        shader.scenePositionIndex = scenePosition.index * 4;
        var skyboxScale = registerCache.getFreeVertexConstant();
        var temp = registerCache.getFreeVertexVectorTemp();
        code += "mul " + temp + ", " + position + ", " + skyboxScale + "\n" +
            "add " + temp + ", " + temp + ", " + scenePosition + "\n";
        if (shader.projectionDependencies > 0) {
            sharedRegisters.projectionFragment = registerCache.getFreeVarying();
            code += "m44 " + temp + ", " + temp + ", " + viewMatrixReg + "\n" +
                "mov " + sharedRegisters.projectionFragment + ", " + temp + "\n" +
                "mov op, " + temp + "\n";
        }
        else {
            code += "m44 op, " + temp + ", " + viewMatrixReg + "\n";
        }
        return code;
    };
    GL_SkyboxElements._getFragmentCode = function (shader, registerCache, sharedRegisters) {
        return "";
    };
    GL_SkyboxElements.prototype.draw = function (renderable, shader, projection, count, offset) {
        var index = shader.scenePositionIndex;
        var camPos = projection.transform.concatenatedMatrix3D.position;
        shader.vertexConstantData[index++] = 2 * camPos.x;
        shader.vertexConstantData[index++] = 2 * camPos.y;
        shader.vertexConstantData[index++] = 2 * camPos.z;
        shader.vertexConstantData[index++] = 1;
        shader.vertexConstantData[index++] = shader.vertexConstantData[index++] = shader.vertexConstantData[index++] = projection.far / Math.sqrt(3);
        shader.vertexConstantData[index] = 1;
        var near = new Vector3D();
        this._skyboxProjection.copyFrom(projection.viewMatrix3D);
        this._skyboxProjection.copyRowTo(2, near);
        var cx = near.x;
        var cy = near.y;
        var cz = near.z;
        var cw = -(near.x * camPos.x + near.y * camPos.y + near.z * camPos.z + Math.sqrt(cx * cx + cy * cy + cz * cz));
        var signX = cx >= 0 ? 1 : -1;
        var signY = cy >= 0 ? 1 : -1;
        var p = new Vector3D(signX, signY, 1, 1);
        var inverse = this._skyboxProjection.clone();
        inverse.invert();
        var q = inverse.transformVector(p);
        this._skyboxProjection.copyRowTo(3, p);
        var a = (q.x * p.x + q.y * p.y + q.z * p.z + q.w * p.w) / (cx * q.x + cy * q.y + cz * q.z + cw * q.w);
        this._skyboxProjection.copyRowFrom(2, new Vector3D(cx * a, cy * a, cz * a, cw * a));
        //set constants
        if (shader.sceneMatrixIndex >= 0)
            shader.sceneMatrix.copyFrom(renderable.renderSceneTransform, true);
        shader.viewMatrix.copyFrom(this._skyboxProjection, true);
        var context = this._stage.context;
        context.setProgramConstantsFromArray(ContextGLProgramType.VERTEX, shader.vertexConstantData);
        context.setProgramConstantsFromArray(ContextGLProgramType.FRAGMENT, shader.fragmentConstantData);
        if (this._indices)
            this.getIndexBufferGL().draw(ContextGLDrawMode.TRIANGLES, 0, this.numIndices);
        else
            this._stage.context.drawVertices(ContextGLDrawMode.TRIANGLES, offset, count || this.numVertices);
    };
    return GL_SkyboxElements;
}(GL_TriangleElements));
export { GL_SkyboxElements };
GL_SkyboxElements.elementsType = "[elements Skybox]";



// WEBPACK FOOTER //
// ../dist/lib/elements/GL_SkyboxElements.js